import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import { Modal, Button, Form } from "react-bootstrap";

import {
  CHECK_ENGINE_STATIC_VIN_REQUEST,
  CHECK_ENGINE_STATIC_VIN_SUCCESS,
  checkEngineStaticVin,
} from "../../../../redux/RegistrationChangesInformationRHFReducer/actionsRegistrationChangesInformationRHF";

import styles from "./engineModal.module.css";

const EngineStaticModal = ({
  onSubmit,
  isOpen,
  onClose,
  initialValues = {},
  remainingPower,
  engpwrmax,
  enginStaticData,
  regNum,
}) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const checkEngineStaticVinLoading = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer
        .checkEngineStaticVinLoading,
  );
  const checkEngineStaticVinError = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.checkEngineStaticVinError,
  );

  const handleClose = () => {
    dispatch({ type: CHECK_ENGINE_STATIC_VIN_REQUEST });
    onClose();
    reset();
  };

  const onFormSubmit = async (data) => {
    if (!regNum) return;

    const isEngnumUnique = enginStaticData.every((item) => {
      return item.engnum !== data.engnum || (data.id && item.id === data.id);
    });

    if (isEngnumUnique) {
      dispatch(checkEngineStaticVin({ engnum: data.engnum, regNum }));
    } else {
      dispatch({
        type: CHECK_ENGINE_STATIC_VIN_SUCCESS,
        payload: "Двигатель с таким номером уже используется в таблице",
      });
    }
  };

  useEffect(() => {
    if (!checkEngineStaticVinLoading && !checkEngineStaticVinError) {
      handleFinalSubmit();
    }
  }, [checkEngineStaticVinLoading, checkEngineStaticVinError]);

  const handleFinalSubmit = () => {
    onSubmit(getValues());
    handleClose();
  };

  useEffect(() => {
    if (isOpen && initialValues) {
      Object.keys(initialValues).forEach((key) => {
        setValue(key, initialValues[key]);
      });
    } else {
      reset();
    }
  }, [isOpen]);

  const validateEnginePower = (value) => {
    if (!value) {
      return true;
    } else if (!engpwrmax) {
      return "Предельная мощность двигателей не заполнена";
    } else if (Number(value) > remainingPower) {
      return `Мощность не может быть больше ${remainingPower}`;
    } else {
      return true;
    }
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Header className={styles["form-header"]} closeButton>
        <Modal.Title className={styles["form-title"]}>
          Информация о двигателе
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <Form onSubmit={handleSubmit(onFormSubmit)}>
          <Form.Group className={styles["form-data"]} controlId="engnum">
            <Form.Label>Заводской (идентификационный) номер</Form.Label>
            <Form.Control
              className={styles["form-input"]}
              type="text"
              placeholder="Введите заводской номер"
              {...register("engnum")}
            />
          </Form.Group>

          <Form.Group className={styles["form-data"]} controlId="engpwr">
            <Form.Label>Мощность, л.с.</Form.Label>
            <Form.Control
              className={styles["form-input"]}
              type="text"
              placeholder="Введите название"
              {...register("engpwr", {
                validate: validateEnginePower,
                onChange: (e) => {
                  e.target.value = e.target.value.replace(",", ".");
                },
              })}
            />
            {errors.engpwr && (
              <p className={styles["error-message"]}>{errors.engpwr.message}</p>
            )}
          </Form.Group>

          {checkEngineStaticVinError && (
            <p className={styles["error-message"]}>
              {checkEngineStaticVinError}
            </p>
          )}

          <div className={styles["form-footer"]}>
            <Button
              className={styles["save-btn"]}
              variant="primary"
              type="submit"
            >
              Сохранить
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EngineStaticModal;
